import { Grid } from '@mantine/core';
import CardLoaderSkeleton from './CardLoaderSkeleton';

export default function CardLoaderSkeletonGridRows({
  cardsQty = 9,
  cardContentRows = 5,
  cardActionsRows = 2
}: {
  cardsQty?: number;
  cardContentRows?: number;
  cardActionsRows?: number;
}) {
  return (
    <Grid gutter="md" pos={'relative'}>
      {Array.from({ length: cardsQty }).map((_, idx) => {
        return (
          <Grid.Col key={idx} span={{ xs: 12, sm: 6, lg: 4 }}>
            <CardLoaderSkeleton
              cardContentRows={cardContentRows}
              cardActionsRows={cardActionsRows}
            />
          </Grid.Col>
        );
      })}
    </Grid>
  );
}
